import { Subject, Observable } from 'rxjs'
import { IIsInViewport } from './queue.interfaces'

class IsInViewport {
  private _subject: Subject<IIsInViewport>

  constructor() {
    this._subject = new Subject()
  }

  emit(value: IIsInViewport): void {
    this._subject.next(value)
  }

  getValue(): Observable<IIsInViewport> {
    return this._subject.asObservable()
  }
}

const SingletonInstance = new IsInViewport()
Object.freeze(SingletonInstance)

export default SingletonInstance
